import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andrea Antonello
 * id 8722C5FB-0644-4837-B497-D16517B9F08D
 * name vector-point-plus
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-point-plus.svg
 * tags
 * - Vector 
 */
export const VectorPointPlusIcon = createSvgIcon(<><path d="M9 9V15H15V9H9M11 11H13V13H11V11M18 15V18H15V20H18V23H20V20H23V18H20V15H18Z" /></>, 'VectorPointPlusIcon');
export default VectorPointPlusIcon